// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentScheduleItemMappingPageQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentScheduleItemMappingPageQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, name: string, scheduleTemplates: Array<{ __typename?: 'ScheduleTemplate', id: string, name: string, status: Types.ScheduleTemplateStatus, stage: Types.Stage, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }>, itemMappings: Array<{ __typename?: 'DevelopmentItemMapping', costType: Types.CostType, stage: Types.Stage, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, name: string }, scheduleTemplateItemMappings: Array<{ __typename?: 'ScheduleTemplateItemMapping', id: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, location: { __typename?: 'Location', id: string }, item: { __typename?: 'Item', id: string }, scheduleTemplate: { __typename?: 'ScheduleTemplate', id: string }, task: { __typename?: 'Task', id: string, name: string } }> }> } };

export type DevelopmentScheduleItemMappingPageFragment = { __typename?: 'Development', id: string, name: string, scheduleTemplates: Array<{ __typename?: 'ScheduleTemplate', id: string, name: string, status: Types.ScheduleTemplateStatus, stage: Types.Stage, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }>, itemMappings: Array<{ __typename?: 'DevelopmentItemMapping', costType: Types.CostType, stage: Types.Stage, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, name: string }, scheduleTemplateItemMappings: Array<{ __typename?: 'ScheduleTemplateItemMapping', id: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, location: { __typename?: 'Location', id: string }, item: { __typename?: 'Item', id: string }, scheduleTemplate: { __typename?: 'ScheduleTemplate', id: string }, task: { __typename?: 'Task', id: string, name: string } }> }> };

export type MappingScheduleTemplateFragment = { __typename?: 'ScheduleTemplate', id: string, name: string, status: Types.ScheduleTemplateStatus, stage: Types.Stage, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } };

export type DevelopmentScheduleItemMappingFragment = { __typename?: 'DevelopmentItemMapping', costType: Types.CostType, stage: Types.Stage, item: { __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, location: { __typename?: 'Location', id: string, name: string }, scheduleTemplateItemMappings: Array<{ __typename?: 'ScheduleTemplateItemMapping', id: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, location: { __typename?: 'Location', id: string }, item: { __typename?: 'Item', id: string }, scheduleTemplate: { __typename?: 'ScheduleTemplate', id: string }, task: { __typename?: 'Task', id: string, name: string } }> };

export const MappingScheduleTemplateFragmentDoc = gql`
    fragment MappingScheduleTemplate on ScheduleTemplate {
  id
  name
  status
  stage
  stageDetail {
    code
    name
  }
}
    `;
export const DevelopmentScheduleItemMappingFragmentDoc = gql`
    fragment DevelopmentScheduleItemMapping on DevelopmentItemMapping {
  item {
    id
    displayName
    costCode {
      id
      displayName
    }
  }
  costType
  location {
    id
    name
  }
  stage
  scheduleTemplateItemMappings {
    id
    costType {
      code
    }
    location {
      id
    }
    item {
      id
    }
    scheduleTemplate {
      id
    }
    task {
      id
      name
    }
  }
}
    `;
export const DevelopmentScheduleItemMappingPageFragmentDoc = gql`
    fragment DevelopmentScheduleItemMappingPage on Development {
  id
  name
  scheduleTemplates {
    ...MappingScheduleTemplate
  }
  itemMappings {
    ...DevelopmentScheduleItemMapping
  }
}
    ${MappingScheduleTemplateFragmentDoc}
${DevelopmentScheduleItemMappingFragmentDoc}`;
export const DevelopmentScheduleItemMappingPageDocument = gql`
    query DevelopmentScheduleItemMappingPage($developmentId: ID!) {
  development(id: $developmentId) {
    ...DevelopmentScheduleItemMappingPage
  }
}
    ${DevelopmentScheduleItemMappingPageFragmentDoc}`;

/**
 * __useDevelopmentScheduleItemMappingPageQuery__
 *
 * To run a query within a React component, call `useDevelopmentScheduleItemMappingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentScheduleItemMappingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentScheduleItemMappingPageQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentScheduleItemMappingPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables> & ({ variables: DevelopmentScheduleItemMappingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>(DevelopmentScheduleItemMappingPageDocument, options);
      }
export function useDevelopmentScheduleItemMappingPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>(DevelopmentScheduleItemMappingPageDocument, options);
        }
// @ts-ignore
export function useDevelopmentScheduleItemMappingPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>;
export function useDevelopmentScheduleItemMappingPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScheduleItemMappingPageQuery | undefined, DevelopmentScheduleItemMappingPageQueryVariables>;
export function useDevelopmentScheduleItemMappingPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>(DevelopmentScheduleItemMappingPageDocument, options);
        }
export type DevelopmentScheduleItemMappingPageQueryHookResult = ReturnType<typeof useDevelopmentScheduleItemMappingPageQuery>;
export type DevelopmentScheduleItemMappingPageLazyQueryHookResult = ReturnType<typeof useDevelopmentScheduleItemMappingPageLazyQuery>;
export type DevelopmentScheduleItemMappingPageSuspenseQueryHookResult = ReturnType<typeof useDevelopmentScheduleItemMappingPageSuspenseQuery>;
export type DevelopmentScheduleItemMappingPageQueryResult = ApolloReactCommon.QueryResult<DevelopmentScheduleItemMappingPageQuery, DevelopmentScheduleItemMappingPageQueryVariables>;